export default {
  monthlyCostButtonColor: 'var( --advisa-blue)',
  monthlyCostPosition: 'center',
  valueFontSize: '1.24rem',
  monthlyCostLabelFontSize: '1rem',
  labelColor: 'var(--black)',
  marginTopForPlus: '-2px',
};
